module.exports = __webpack_public_path__ + "static/img/error.8d889ac9.png";